<template>
  <!-- rotate 50 slide做3d旋转时Y轴的旋转角度 -->
  <!-- stretch 0 每个slide之间的拉伸值，越大slide靠得越紧。5.3.6 后可使用%百分比 -->
  <!-- depth 100 slide的位置深度。值越大z轴距离越远，看起来越小。 -->
  <!-- modifier 1 depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。 -->
  <!-- slideShadows true 是否开启slide阴影 -->
  <div class="game">
    <swiper
      :observer="true"
      :watchSlidesProgress='true'
      :speed="500"
      :effect="'coverflow'"
      :grabCursor="true"
      :centeredSlides="true"
      :autoplay="true"
      :slidesPerView="'auto'"
      :loop="true"
      :loopedSlides="3"
      :initialSlide="0"
      :coverflowEffect="{
        rotate: 0,
        stretch: '70%',
        depth: 400,
        modifier: 1,
        slideShadows: true,
      }"
      :modules="modules"
      :navigation="{
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
        }"
      :class="deviceType()"
      class="mySwiper"
      v-if="Banner"
    >
      <swiper-slide
        v-for="(value, index) in Banner"
        v-bind:key="index"
      >
        <template
          v-for="(i, key) in value"
          v-bind:key="key"
        >
          <img
            v-if="deviceType() == i.label"
            :src="i.content"
            v-bind:key="key"
          />
        </template>
      </swiper-slide>

      <!-- 分页器 -->
      <div class="swiper-pagination"></div>

      <!-- 自定义导航按钮 -->
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
    </swiper>
  </div>
</template>
<script setup>
import { defineProps, watch, ref } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { EffectCoverflow, Pagination, Navigation } from "swiper/modules";
import { deviceType } from "@/util/base";

const props = defineProps(["BannerData"]);
const modules = [EffectCoverflow, Pagination, Navigation];
const Banner = ref("");

watch(
  [() => props.BannerData],
  ([newVal]) => {
    if (newVal) {
      Banner.value = newVal;
    }
  },
  { immediate: true }
);
</script>

<style lang=scss scoped>
.mySwiper {
  z-index: 998;

  .swiper {
    width: 100%;
  }

  .swiper-slide {
    background-position: center;
    background-size: cover;
    width: 8.77rem;
    opacity: 0;
  }

  .swiper-slide img {
    display: block;
    width: 100%;
  }
  .swiper-slide-active,
  .swiper-slide-prev,
  .swiper-slide-next {
    opacity: 1;
  }

  .swiper-container {
    transform: translate3d(0, 0, 0);
  }

  /* 修改导航按钮的颜色 */
  .swiper-button-next {
    width: 1.06rem;
    height: 1.17rem;
    background: url("../../../assets/images/next.png") no-repeat;
    background-size: 100% auto;
    right: 15%;
    top: 50%;
    margin-top: -0.585rem;
  }
  .swiper-button-prev {
    width: 1.06rem;
    height: 1.17rem;
    background: url("../../../assets/images/prev.png") no-repeat;
    background-size: 100% auto;
    left: 15%;
    top: 50%;
    margin-top: -0.585rem;
  }

  /* 修改导航按钮的背景色 */
  .swiper-button-next::after,
  .swiper-button-prev::after {
    display: none;
  }

  /* 自定义导航按钮的样式 */
  .swiper-button-next,
  .swiper-button-prev {
    /* 在这里添加你的自定义样式，比如背景图片、边框等 */
  }

  /* 鼠标悬停时的样式 */
  .swiper-button-next:hover,
  .swiper-button-prev:hover {
    /* 在这里添加悬停时的样式，比如改变颜色或大小 */
  }
  &.wap {
    .swiper-slide {
      background-position: center;
      background-size: cover;
      width: 5.89rem;
      margin-top: 0.15rem;
    }
    /* 修改导航按钮的颜色 */
    .swiper-button-next {
      width: 0.64rem;
      height: 0.7rem;
      background: url("../../../assets/images/next.png") no-repeat;
      background-size: 100% auto;
      right: 0.5%;
      top: 50%;
      margin-top: -0.4rem;
    }
    .swiper-button-prev {
      width: 0.64rem;
      height: 0.7rem;
      background: url("../../../assets/images/prev.png") no-repeat;
      background-size: 100% auto;
      left: 0.5%;
      top: 50%;
      margin-top: -0.4rem;
    }
  }
}
</style>